import { ReactNode, HTMLAttributes, CSSProperties } from 'react';
import useSmartEdit from '@smartedit/hooks/useSmartEdit';
import useCmsTicketId from '@hooks/useCmsTicketId';

interface Props extends HTMLAttributes<HTMLDivElement> {
  type: string;
  uuid?: string;
  uid?: string;
  children: ReactNode;
}

const SmartEditWrapper = ({ type, uuid, uid, children, className, style, ...rest }: Props) => {
  const { isSmartEditEnabled, catalogVersionUuid } = useSmartEdit(useCmsTicketId());

  const shouldRenderDiv = isSmartEditEnabled || type === 'ContentSlot';

  if (shouldRenderDiv) {
    const combinedClassName = [isSmartEditEnabled ? 'smartEditComponent' : null, className].filter(Boolean).join(' ');

    // For grid components, we need to use display: contents to avoid breaking grid layout
    const isGridComponent = type === 'SmallGridPackageComponent' || type === 'ImageGridComponent';
    const wrapperStyle: CSSProperties = isGridComponent ? { display: 'contents', ...style } : style || {};

    return isSmartEditEnabled ? (
      <div
        className={combinedClassName || undefined}
        data-smartedit-component-type={type}
        data-smartedit-component-uuid={uuid}
        data-smartedit-component-id={uid}
        data-smartedit-catalog-version-uuid={catalogVersionUuid}
        style={wrapperStyle}
        {...rest}
      >
        {children}
      </div>
    ) : (
      <div className={combinedClassName || undefined} style={wrapperStyle} {...rest}>
        {children}
      </div>
    );
  }

  return <>{children}</>;
};

export default SmartEditWrapper;
